import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg style={{ display: "block" }} viewBox="0 0 24 24" version="1.1" {...props}>
    <title>0: Icons / Tick</title>
    <g id="0:-Icons-/-Tick" stroke="none" strokeWidth="1">
        <path d="M9 16.172l10.594-10.594 1.406 1.406-12 12-5.578-5.578 1.406-1.406z"></path>
    </g>
</svg>;
